import { ArrowBackIos } from "@mui/icons-material";
import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { showNotification } from "../../components/Notification";
import { useSelector } from "react-redux";
import { getDepartment } from "../department/departmentSlice";

export default function ViewTemplateDetails({ selectedTemplate }) {
  const navigate = useNavigate();
  const allDepartments = useSelector(getDepartment);
  return (
    <div>
      <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="flex w-full  items-center bg-primary">
          <button
            onClick={() => navigate("/admin/template")}
            className="flex w-32 pl-3 text-white cursor-pointer bg-transparent border-none hover:bg-blue-600 transition-colors"
            aria-label="Go back to template list"
          >
            <ArrowBackIos /> Go Back
          </button>
          <h1 className="w-full lg:text-title-sm text-title-xsm text-center font-semibold text-white bg-primary dark:text-white py-3">
            <span className="ml-4">Template Details</span>
          </h1>
          <div className="w-34" />
        </div>
        <div className="p-4">
          <div className="font-bold text-xl mb-2">
            {selectedTemplate?.templateTitle}
          </div>
          <div className="mb-10">
            {`Business Unit: ${
              allDepartments?.find(
                (dept) => dept?.id === selectedTemplate?.businessUnit
              )?.departmentName
            }`}
          </div>
          <div>
            {selectedTemplate.appraisalQuestions?.map((question, qIndex) => (
              <div key={question?.id || `question-${qIndex}`} className="mb-5">
                <div className="font-semibold text-base ml-2">
                  {`${qIndex + 1}. ${question.questionTitle}`}
                </div>
                <div className="ml-8">{question.questionSubTitle}</div>
                <div className="mt-4 ml-12">
                  {question.questionOptions?.map((optionObj, optionIndex) => {
                    const optionValue = optionObj?.["optionTitle"];

                    return (
                      <button
                        key={
                          optionObj?.id ||
                          `option-${question?.id}-${optionIndex}`
                        }
                        onClick={() => {
                          showNotification("info", "You're in view mode");
                        }}
                        className="w-full text-left cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors border-none bg-transparent"
                      >
                        <span className="font-medium mr-2">
                          {String.fromCharCode(65 + optionIndex)}.
                        </span>
                        {question.optionType === 1 ? (
                          <input type="checkbox" className="mr-2" disabled />
                        ) : (
                          <input
                            type="radio"
                            className="mr-2"
                            name={`question-${question?.id}`}
                            disabled
                          />
                        )}
                        {optionValue}
                      </button>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

ViewTemplateDetails.propTypes = {
  selectedTemplate: PropTypes.shape({
    templateTitle: PropTypes.string,
    businessUnit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    appraisalQuestions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        questionTitle: PropTypes.string,
        questionSubTitle: PropTypes.string,
        optionType: PropTypes.number,
        questionOptions: PropTypes.arrayOf(
          PropTypes.shape({
            optionTitle: PropTypes.string,
          })
        ),
      })
    ),
  }),
};

ViewTemplateDetails.defaultProps = {
  selectedTemplate: {
    templateTitle: "",
    businessUnit: null,
    appraisalQuestions: [],
  },
};
